import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
export class HotjarLoader {
    static init() {
        var _ClientUserState_userState;
        if (this.initialized) return;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        var _ClientUserState_userState_totalCompletedGameCount;
        if (((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) > 0) return;
        if (window.location.protocol != 'https:') return;
        (function(h, o, t, j, a, r) {
            var _h_hj;
            h.hj = (_h_hj = h.hj) !== null && _h_hj !== void 0 ? _h_hj : function() {
                var _h_hj_q;
                // eslint-disable-next-line prefer-rest-params
                (h.hj.q = (_h_hj_q = h.hj.q) !== null && _h_hj_q !== void 0 ? _h_hj_q : []).push(arguments);
            };
            h._hjSettings = {
                hjid: UIUtilsEjsVariables.hotjarTrackingCode,
                hjsv: 6
            };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
        this.initialized = true;
    }
}
HotjarLoader.initialized = false;
